import { ProductVariantBulkDiscount } from "../product.types";

export const createInitialBulkDiscounts = (): ProductVariantBulkDiscount[] => {
  return [
    { min: 5, max: 10, discount: null },
    { min: 11, max: 15, discount: null },
    { min: 16, max: 999999, discount: null }
  ];
};
